import { create } from 'zustand';

const useImageListStore = create((set, get) => ({
  imageListMap: {}, // { [storeBusinessNumber]: [...] }

  setImageList: (storeBusinessNumber, imageList) => {
    set((state) => ({
      imageListMap: {
        ...state.imageListMap,
        [storeBusinessNumber]: imageList,
      },
    }));
  },

  getImageList: (storeBusinessNumber) => {
    return get().imageListMap[storeBusinessNumber] || null;
  },
}));

export default useImageListStore;
